



import { defineComponent } from '@vue/composition-api';

import UserSelectionsContainer from '@app/modules/sportOffer/UserSelectionsContainer.vue';

export default defineComponent({
    name: 'UserSelectionsContainerFixed',
    components: {
        UserSelectionsContainer,
    },
});
